import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseDto } from '../../../shared/modules/base/dtos/base.dto';
import { ComputedPeriodDurationDto } from '../../../shared/modules/shared/dtos/computed-period-duration.dto';
import { SupplierListDto } from '../../suppliers/dtos/supplier-list.dto';
import { TagListDto } from '../../tags/dtos/tag-list.dto';
import { VehicleListDto } from '../../vehicles/dtos/vehicle-list.dto';
import { VehicleMaintenanceRecordCategoryEnum } from '../enums/vehicle-maintenance-record-category.enum';
import { VehicleMaintenanceStatusEnum } from '../enums/vehicle-maintenance-status.enum';

import { VehicleMaintenanceLinksDto } from './vehicle-maintenance-links.dto';

/**
 * Vehicle maintenance DTO for lists
 */
@CaslSubject(AppSubjectEnum.VEHICLE_MAINTENANCE)
export class VehicleMaintenanceListDto extends BaseDto {
  code!: string;
  documentNumber!: string;
  externalReference?: string | null;
  recordCategory!: VehicleMaintenanceRecordCategoryEnum;
  status!: VehicleMaintenanceStatusEnum;
  startsAt?: Date | null;
  endsAt?: Date | null;
  estimatedCost?: number | null;
  serviceCenter?: string | null;
  vehicle?: VehicleListDto | null;
  supplier?: SupplierListDto | null;
  tags?: TagListDto[] | null;
  links?: VehicleMaintenanceLinksDto | null;
  computedPeriod?: ComputedPeriodDurationDto | null;
  computedTotalNet?: number | null;
  computedTotalTax?: number | null;
  computedTotalGross?: number | null;
}
